const FacebookIcon = ({ width = 16, height = 16, color = "white" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1H6.09091C5.24704 1 4.43773 1.34241 3.84102 1.9519C3.24432 2.5614 2.90909 3.38805 2.90909 4.25V6.2H1V8.8H2.90909V14H5.45455V8.8H7.36364L8 6.2H5.45455V4.25C5.45455 4.07761 5.52159 3.91228 5.64093 3.79038C5.76027 3.66848 5.92213 3.6 6.09091 3.6H8V1Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FacebookIcon;
